module.exports = __webpack_public_path__ + "media/images/vector-8409d243.svg";